import React, { useEffect, useState } from "react";
import "./header.scss";
import { useLocation, useWindowSize } from "react-use";
import { closeIcon, pathwaysLogo, pathwaysLogoGreen } from "../../source";
import {
  aboutUsURL,
  contactUsURL,
  homeURL,
  interviewsURL,
  reflectionsURL,
} from "../../helpers/constants";
import { Link, NavLink } from "react-router-dom";
import HeaderNavItem from "./HeaderNavItem";
const body = document.querySelector("body");

const menuData = [
  {
    id: 1,
    type: "text",
    mainTitle: "About",
    mainLink: aboutUsURL,
  },
  {
    id: 2,
    type: "text",
    mainTitle: "Interviews",
    mainLink: interviewsURL,
  },
  // {
  //   id: 3,
  //   type: "text",
  //   mainTitle: "Events",
  //   mainLink: homeURL,
  // },
  // {
  //   id: 4,
  //   type: "text",
  //   mainTitle: "Consultations",
  //   mainLink: homeURL,
  // },
  // {
  //   id: 5,
  //   type: "text",
  //   mainTitle: "Merchandise",
  //   mainLink: homeURL,
  // },
  {
    id: 6,
    type: "text",
    mainTitle: "Reflections",
    mainLink: reflectionsURL,
  },
  {
    id: 7,
    type: "text",
    mainTitle: "Contact Us",
    mainLink: contactUsURL,
  },
];

const Header = () => {
  const { width } = useWindowSize();
  const [isBg, setIsbg] = useState(false);
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [navActiveIndex, setNavActiveIndex] = useState(null);
  const { pathname: locationPathname } = useLocation();

  const navlinkList = menuData.map((nav, i) => (
    <li className="link_item" key={`menu-item-${menuData[i].id}`}>
      <div>
        <NavLink
          className={({ isActive }) =>
            isActive ? "nav_tab active" : "nav_tab"
          }
          to={nav.mainLink}
        >
          {nav.mainTitle}
        </NavLink>
      </div>
    </li>
  ));

  useEffect(() => {
    body.style.overflow = "auto";
    // if (locationPathname === "/") {
    //   setIsbg(false);
    // } else {
    //   setIsbg(true);
    // }
    setIsMenuActive(false);
  }, [locationPathname]);

  const handleScroll = () => {
    // if (window.location.pathname === "/")
    if (window.scrollY > 60) {
      setIsbg(true);
    } else {
      setIsbg(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", () => handleScroll);
    };
  });

  const scrollHandler = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const handleHamburgerClick = () => {
    setIsMenuActive(!isMenuActive);
    if (!isMenuActive) {
      // Disable scroll
      body.style.overflow = "hidden";
    } else {
      // Enable scroll
      body.style.overflow = "auto";
    }
  };

  const handleNavIndex = (i) => {
    if (navActiveIndex === i) {
      setNavActiveIndex(null);
    } else {
      setNavActiveIndex(i);
    }
  };

  useEffect(() => {
    setNavActiveIndex(false);
  }, [isMenuActive]);

  return (
    <>
      <header className={`header ${isBg ? "active" : ""}`}>
        {width >= 1024 ? (
          <div className="navlinks_wrapper">
            <div className="logo_wrapper">
              <Link to={homeURL}>
                <img
                  className="logo_img"
                  src={pathwaysLogo}
                  alt="interact Logo"
                  onClick={scrollHandler}
                />
              </Link>
            </div>

            <div className="link_wrapper">
              <ul className="link_list">{navlinkList}</ul>
            </div>
          </div>
        ) : (
          <>
            <div className="my_container">
              <div
                className={`hamburger_link_wrapper ${
                  isMenuActive ? "active" : ""
                }`}
              >
                <div
                  className={`hamburger_wrapper ${
                    isMenuActive ? "active" : ""
                  }`}
                >
                  <div className="logo_wrapper">
                    <Link className="logo_link" to={homeURL}>
                      <img
                        // src={isMenuActive ? pathwaysLogoGreen : pathwaysLogo}
                        src={pathwaysLogo}
                        alt="pathways logo"
                        className="pathways_logo img-fluid"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`mobile_header_wrapper ${
                isMenuActive ? "active" : ""
              }`}
            >
              <div className="logo_wrapper">
                <Link className="logo_link" to={homeURL}>
                  <img
                    src={pathwaysLogoGreen}
                    alt="pathways logo"
                    className="pathways_logo img-fluid"
                  />
                </Link>
              </div>
              <ul className="mobile_links_wrapper">
                {menuData.map((navData, i) => (
                  <HeaderNavItem
                    navData={navData}
                    key={parseInt(navData.id)}
                    arrIndex={i}
                    handleNavIndex={handleNavIndex}
                    navActiveIndex={navActiveIndex}
                  />
                ))}
              </ul>
            </div>

            <div
              className={`hamburger_lines ${
                isMenuActive ? "active" : "" || isBg ? "black" : ""
              }`}
              onClick={handleHamburgerClick}
            >
              {isMenuActive ? (
                <img src={closeIcon} alt="close" className="menu_close_icon" />
              ) : (
                <>
                  <div className="line line1"></div>
                  <div className="line line2"></div>
                  <div className="line line3"></div>
                </>
              )}
            </div>
          </>
        )}
      </header>
    </>
  );
};

export default Header;
